import type { ColumnDef } from '@tanstack/vue-table'
import { getColumnByStringIndex } from 'pejer/src/utils'
import { h } from 'vue'

import FragmentedBar, { type FragmentedBarSection } from 'pejer/src/components/FragmentedBar.vue'
import MoneyFormatted from 'pejer/src/components/MoneyFormatted.vue'
import DataTableGoto from 'pejer/src/components/Table/core/DataTableGoto.vue'

import { getDefaultColumn } from 'pejer/src/helpers'
import { Payment } from 'pejer/src/tables/Payment'
import { wrapCellInClipboardCopy } from '../../tables/helpers'

export const paymentsColumns: ColumnDef<Payment.ListItem>[] = [
  {
    accessorKey: 'customer.name',
  },
  {
    accessorKey: 'customer.email',
  },
  {
    accessorKey: 'connectedAccount.name',
  },
  {
    accessorKey: 'connectedAccount.businessName',
  },
  {
    accessorKey: 'description',
  },
  {
    accessorKey: 'paymentStatus',
  },
  {
    accessorKey: 'grossAmount',
  },
  {
    accessorKey: 'platformProfit',
    header: 'Profit',
    meta: {
      sortable: true,
      group: 'Gross amount',
    },
    size: 100,
    cell: ({ row }) => {
      return wrapCellInClipboardCopy(
        () =>
          h(MoneyFormatted, {
            amount: row.original.platformProfit,
            oneSize: true,
            // TODO: Add currency to the Payments table
            currency: 'NOK', // row.original.currency
            showColor: true,
          }),
        row.original.platformProfit
      )
    },
  },
  {
    id: 'moneySplit',
    header: 'Money split',
    meta: {
      group: 'Gross amount',
    },
    size: 100,
    cell: ({ row }) => {
      const colors = ['badge-success', 'badge-gray']

      const sections: FragmentedBarSection[] = [
        {
          amount: row.original.moneySplitNotFee,
          class: colors[0],
          showLabel: true,
          name: 'Not fee',
        },
        {
          amount: row.original.moneySplitFee,
          class: colors[1],
          showLabel: true,
          name: 'Fee',
        },
      ]

      return h(FragmentedBar, {
        sections,
      })
    },
  },
  {
    accessorKey: 'insertTime',
    header: 'Created',
    meta: {
      sortable: true,
    },
  },
  {
    id: 'actions',
    meta: {
      placement: 'end',
    },
    size: 40,
    cell: ({ row }) => {
      const payment = row.original

      return h(
        'div',
        { style: { display: 'flex', justifyContent: 'end' } },
        h(DataTableGoto, {
          name: 'Payment',
          id: getColumnByStringIndex(payment, getDefaultColumn('payments').id),
          pathName: 'payment',
        })
      )
    },
  },
]
